import { createGlobalStyle } from "styled-components";
import poppin from '../fonts/poppins-v20-latin-regular.woff2'
import { CustomThemeInterface } from "./Themes";

const GlobalStyle = createGlobalStyle<{theme: CustomThemeInterface}>`
    @font-face {
        font-family: 'Spartan';
        src: local('Spartan'), local(''),
        url(${poppin});
        font-weight: 400;
        font-style: normal;
    }
    body, html {
        transition: all 0.50s linear;
        margin: 0;
        color: ${props => props.theme.body};
        background: ${props => props.theme.background};
        font-family: "Spartan", Arial;
        font-weight: 400;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

`;

export default GlobalStyle;
